export const convertRelationRelnrToName = (relationNumber:any, relations:any) => {
    if(Array.isArray(relations)){
        let obj = {}
        for (let i = 0; i < relations.length; i++) {
            if(relations[i].split("_")[0].toString().includes(relationNumber.toString())){
                obj = relations[i]
            }
        }
        return obj;
    }
    return {}
}

export const getContent = (page:any, label:any, language:any, content:any, defaultvalue:any) => {
    return content[language] ? (content[language][page][label] ? content[language][page][label] : defaultvalue) : defaultvalue
}

export const convertGroupidToGroup = async (groupid:any, user:any) => {
    let groups = "";
    let fet = await fetch(process.env.REACT_APP_SERVER_LINK+"getGroupsAll?token="+user.token)
    let res = await fet.json();

    if(res.errorcode === 0){groups = res.object}

    if(!isNaN(parseFloat(groupid)) && Array.isArray(groups)){
        let obj:any = {}
        for (let i = 0; i < groups.length; i++) {
            if(groups[i].groupid.toString() === groupid.toString()){
                obj = groups[i]
            }
        }
        return obj;
    }
    else {
        //console.log("No groups")
        return null;
        
    }
}

export const getRelnrsString = async (user:any) => {
    let arr = [];

    const group = await convertGroupidToGroup(user.group, user) as any
    if(group){
        if(Array.isArray(group.members)){arr = group.members}
    }

    let userRelnr = user.relnr;
    if(!arr.includes(userRelnr)){
        arr.push(userRelnr)
    }

    let relnrs = await arr.join("|")
    let metafilter = "";
    if(parseFloat(user.role) === 2){
        //EM
        metafilter = "RELNR_EM="+relnrs;
    }
    else if(parseFloat(user.role) === 3){
        //Afnemer
        metafilter = "RELNR_AF="+relnrs;
    }
    else if(parseFloat(user.role) === 4){
        //Aanbieder
        metafilter = "RELNR_AB="+relnrs;
    }

    return metafilter; 
}

export const dateToYYYYMMDD = (date:any) => {
    let d = date.getDate().toString();
    if(d.length < 2){d = "0"+d}
    let m = (date.getMonth() + 1).toString();
    if(m.length < 2){m = "0"+m}
    let y = date.getFullYear().toString();

    return y + m + d;
}